/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface InferredProjectDescriptionField
 */
export interface InferredProjectDescriptionField extends UpdatedField {
    /**
     * 
     * @type {string}
     * @memberof InferredProjectDescriptionField
     */
    value: string;
}

/**
 * Check if a given object implements the InferredProjectDescriptionField interface.
 */
export function instanceOfInferredProjectDescriptionField(value: object): value is InferredProjectDescriptionField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function InferredProjectDescriptionFieldFromJSON(json: any): InferredProjectDescriptionField {
    return InferredProjectDescriptionFieldFromJSONTyped(json, false);
}

export function InferredProjectDescriptionFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): InferredProjectDescriptionField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': json['value'],
    };
}

export function InferredProjectDescriptionFieldToJSON(value?: InferredProjectDescriptionField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': value['value'],
    };
}

